const INK = '#241a2f';
const FABRIC = '#f4f0e6';
const DARK_FABRIC = '#3a2d4d';
const LINE = 'rgba(120,110,130,.9)';
const ACCENT = '#ff6a3d';

const SPECS = {
  'skydive:malfunction-handle': {kind: 'freefall', preset: 'handle'},
  'skydive:malfunction-horseshoe': {kind: 'freefall', preset: 'horseshoe'},
  'skydive:malfunction-delay': {kind: 'freefall', preset: 'delay'},
  'skydive:malfunction-pack-lock': {kind: 'freefall', preset: 'pack-lock'},
  'skydive:malfunction-bag-lock': {kind: 'freefall', preset: 'bag-lock'},
  'skydive:malfunction-streamer': {kind: 'freefall', preset: 'streamer'},
  'skydive:malfunction-line-over': {kind: 'canopy', preset: 'line-over'},
  'skydive:malfunction-tangled-lines': {kind: 'canopy', preset: 'tangled'},
  'skydive:malfunction-broken-lines': {kind: 'canopy', preset: 'broken-lines'},
  'skydive:malfunction-slider-hang': {kind: 'canopy', preset: 'slider-hang'},
  'skydive:malfunction-line-twist': {kind: 'canopy', preset: 'line-twist'},
};

const styles = `
  .malfunction-runtime { width:100%; height:100%; display:grid; place-items:center; }
  .malfunction-runtime svg { width:100%; height:100%; display:block; overflow:visible; }
  .malfunction-runtime[data-library-card="true"] * { animation-play-state:paused !important; }
  .malfunction-runtime[data-library-card="true"]:hover * { animation-play-state:running !important; }
  .mal-streak { stroke:#fdf1e0; stroke-width:3; stroke-linecap:round; opacity:.3;
    animation:mal-streak 2.46s linear infinite; }
  .mal-streak:nth-child(2) { animation-delay:-.7s; }
  .mal-streak:nth-child(3) { animation-delay:-1.4s; }
  .mal-streak:nth-child(4) { animation-delay:-.25s; }
  .mal-streak:nth-child(5) { animation-delay:-1s; }
  .mal-streak:nth-child(6) { animation-delay:-1.8s; }
  .mal-jumper, .mal-deployment, .mal-canopy-root, .mal-wing-system {
    transform-box:fill-box; transform-origin:center; }
  .mal-handle-hand { animation:mal-handle 4.8s cubic-bezier(.65,0,.35,1) infinite; }
  .mal-handle-zone { transform-box:fill-box; transform-origin:center;
    animation:mal-zone 1.4s ease-in-out infinite; }
  .mal-attempt-one { animation:mal-attempt-one 4.8s linear infinite; }
  .mal-attempt-two { animation:mal-attempt-two 4.8s linear infinite; }
  .mal-horseshoe-jumper { animation:mal-horseshoe-body 2.2s ease-in-out infinite alternate; }
  .mal-horseshoe-bridle { stroke-dasharray:1; stroke-dashoffset:1;
    animation:mal-draw-unit .8s .5s ease-out forwards; }
  .mal-horseshoe-pc { transform-box:fill-box; transform-origin:center;
    animation:mal-pop .4s 1.15s cubic-bezier(.2,1.5,.45,1) backwards; }
  .mal-delay-pc { transform-box:fill-box; transform-origin:center;
    animation:mal-delay-flutter 1.6s .7s ease-in-out infinite alternate; }
  .mal-swirl-a { transform-box:fill-box; transform-origin:center; animation:mal-spin 3s linear infinite; }
  .mal-swirl-b { transform-box:fill-box; transform-origin:center; animation:mal-spin 4.5s linear infinite reverse; }
  .mal-pack-pc { transform-box:fill-box; transform-origin:center;
    animation:mal-pack-pull 1s cubic-bezier(.2,.8,.2,1) both, mal-pack-bob .7s 1s ease-in-out infinite alternate; }
  .mal-lock-ring { transform-box:fill-box; transform-origin:center;
    animation:mal-zone 1.2s .8s ease-in-out infinite; }
  .mal-deployment { animation:mal-deploy .8s ease-out both, mal-deploy-bob 1s .8s ease-in-out infinite alternate; }
  .mal-bag { transform-box:fill-box; transform-origin:center; animation:mal-bag-shake .6s .8s ease-in-out infinite; }
  .mal-streamer { animation:mal-stream-wave .9s .8s ease-in-out infinite alternate; }
  .mal-canopy-root { animation:mal-rig-enter .85s cubic-bezier(.2,.8,.2,1) both,
    mal-canopy-sway 2.2s .85s ease-in-out infinite alternate; }
  .mal-over-line { stroke-dasharray:680; stroke-dashoffset:680;
    animation:mal-draw 1s .2s ease-out forwards; }
  .mal-knot { transform-box:fill-box; transform-origin:center; animation:mal-knot .9s ease-out both; }
  .mal-broken { animation:mal-broken 1.1s ease-in-out infinite alternate; }
  .mal-slider { transform-box:fill-box; transform-origin:center;
    animation:mal-slider .9s ease-out both, mal-zone 1.4s .9s ease-in-out infinite; }
  .mal-slider-wing { animation:mal-slider-breathe 1.4s .9s ease-in-out infinite alternate; }
  .mal-braid { stroke-dasharray:500; stroke-dashoffset:500;
    animation:mal-draw .9s .45s ease-out forwards; }
  @keyframes mal-streak { from { transform:translateY(330px) } to { transform:translateY(-330px) } }
  @keyframes mal-zone { 0%,100% { opacity:.38; transform:scale(.92) } 50% { opacity:1; transform:scale(1.24) } }
  @keyframes mal-handle {
    0%,8% { transform:translate(0,0) } 22% { transform:translate(116px,38px) }
    27% { transform:translate(124px,38px) } 32% { transform:translate(112px,38px) }
    43% { transform:translate(42px,4px) } 58% { transform:translate(102px,28px) }
    63% { transform:translate(110px,28px) } 68%,100% { transform:translate(96px,28px) }
  }
  @keyframes mal-attempt-one { 0%,7%,46%,100% { opacity:0 } 10%,42% { opacity:1 } }
  @keyframes mal-attempt-two { 0%,45%,100% { opacity:0 } 49%,94% { opacity:1 } }
  @keyframes mal-horseshoe-body { from { transform:rotate(-22deg) } to { transform:rotate(-12deg) } }
  @keyframes mal-draw-unit { to { stroke-dashoffset:0 } }
  @keyframes mal-pop { from { opacity:0; transform:scale(0) } to { opacity:1; transform:scale(1) } }
  @keyframes mal-delay-flutter { from { transform:translate(-4px,-10px) rotate(-8deg) }
    to { transform:translate(10px,18px) rotate(10deg) } }
  @keyframes mal-spin { to { transform:rotate(360deg) } }
  @keyframes mal-pack-pull { from { opacity:0; transform:translateY(340px) scale(0) }
    to { opacity:1; transform:translateY(0) scale(1) } }
  @keyframes mal-pack-bob { from { translate:0 -8px } to { translate:0 6px } }
  @keyframes mal-deploy { from { opacity:0; transform:translateY(80px) } to { opacity:1; transform:translateY(0) } }
  @keyframes mal-deploy-bob { from { translate:0 0 } to { translate:0 8px } }
  @keyframes mal-bag-shake { 0%,100% { transform:rotate(-6deg) } 50% { transform:rotate(6deg) } }
  @keyframes mal-stream-wave { from { transform:translateX(-7px) skewX(-4deg) }
    to { transform:translateX(7px) skewX(4deg) } }
  @keyframes mal-rig-enter { from { opacity:0; transform:translateY(55px) scale(.9) }
    to { opacity:1; transform:translateY(0) scale(1) } }
  @keyframes mal-canopy-sway { from { rotate:-4deg } to { rotate:5deg } }
  @keyframes mal-draw { to { stroke-dashoffset:0 } }
  @keyframes mal-knot { from { opacity:0; transform:scale(0) } to { opacity:1; transform:scale(1) } }
  @keyframes mal-broken { from { opacity:.42 } to { opacity:1 } }
  @keyframes mal-slider { from { opacity:0; transform:translateY(-75px) }
    to { opacity:1; transform:translateY(0) } }
  @keyframes mal-slider-breathe { from { transform:scaleX(.96) } to { transform:scaleX(1.08) } }
`;

const pilotChute = className => `
  <g class="${className}">
    <path d="M-24 0 H24 L0 26 Z" fill="rgba(244,240,230,.9)" />
    <path d="M-29 0 A29 28 0 0 1 29 0 Z" fill="${DARK_FABRIC}"
      stroke="rgba(253,241,224,.7)" stroke-width="2.5" />
  </g>`;

const slackPilotChute = className => `
  <g class="${className}">
    <ellipse rx="20" ry="8" transform="rotate(-16)" fill="${DARK_FABRIC}"
      stroke="rgba(253,241,224,.45)" stroke-width="1.5" />
    <ellipse cx="-2" cy="6" rx="12" ry="3.5" transform="rotate(-16 -2 6)"
      fill="rgba(244,240,230,.4)" />
  </g>`;

const jumper = (className, extra = '') => `
  <g transform="translate(0 150)">
    <g class="mal-jumper ${className}">
      <rect x="-79" y="-34" width="54" height="16" rx="8" fill="${INK}"
        transform="rotate(-40 -52 -26)" />
      <circle cx="-88" cy="-2" r="20" fill="${INK}" />
      <rect x="-65" y="-20" width="130" height="40" rx="20" fill="${INK}" />
      <rect x="43" y="-22" width="66" height="20" rx="10" fill="${INK}"
        transform="rotate(-26 76 -12)" />
      <rect x="93" y="-55" width="58" height="14" rx="7" fill="${INK}"
        transform="rotate(-62 122 -48)" />
      <rect x="-42" y="-47" width="64" height="26" rx="9" fill="${DARK_FABRIC}"
        stroke="rgba(253,241,224,.4)" stroke-width="2" />
      ${extra}
    </g>
  </g>`;

const streaks = () => [-250, -160, -50, 70, 180, 265]
  .map((x, index) => `<path class="mal-streak" d="M${x} 0v46" style="animation-delay:${-index * .31}s" />`)
  .join('');

const freefallVisual = preset => {
  let overlay = '';
  let bodyClass = '';
  if (preset === 'handle') {
    overlay = `
      <circle class="mal-handle-zone" cx="26" cy="-24" r="22" fill="none"
        stroke="${ACCENT}" stroke-width="3" stroke-dasharray="6 8" />
      <circle class="mal-handle-hand" cx="-72" cy="-44" r="10" fill="${ACCENT}" />`;
  } else if (preset === 'horseshoe') {
    bodyClass = 'mal-horseshoe-jumper';
    overlay = `
      <path class="mal-horseshoe-bridle" pathLength="1" d="M-10-44 Q46-174 124-60"
        fill="none" stroke="${LINE}" stroke-width="2.5" stroke-linecap="round" />
      <g transform="translate(132 -64) rotate(24)">${slackPilotChute('mal-horseshoe-pc')}</g>`;
  }

  let external = '';
  if (preset === 'handle') {
    external = `
      <text class="mal-attempt-one" x="0" y="270" text-anchor="middle" fill="${ACCENT}"
        font-family="JetBrains Mono,monospace" font-size="30" font-weight="800" letter-spacing="3">FÖRSÖK 1</text>
      <text class="mal-attempt-two" x="0" y="270" text-anchor="middle" fill="${ACCENT}"
        font-family="JetBrains Mono,monospace" font-size="30" font-weight="800" letter-spacing="3">FÖRSÖK 2</text>`;
  } else if (preset === 'delay') {
    external = `
      <path d="M-10 116 Q-55 34-14-90" fill="none" stroke="${LINE}" stroke-width="2" />
      <g transform="translate(-14 -100)">${slackPilotChute('mal-delay-pc')}</g>
      <g transform="translate(-10 -70)" fill="none">
        <circle class="mal-swirl-a" r="85" stroke="rgba(253,241,224,.4)" stroke-width="3"
          stroke-dasharray="10 14" />
        <circle class="mal-swirl-b" r="125" stroke="rgba(253,241,224,.28)" stroke-width="3"
          stroke-dasharray="10 16" />
      </g>`;
  } else if (preset === 'pack-lock') {
    external = `
      <path d="M-10 116 L-10-274" fill="none" stroke="${LINE}" stroke-width="2" />
      <g transform="translate(-10 -300)">${pilotChute('mal-pack-pc')}</g>
      <circle class="mal-lock-ring" cx="-10" cy="104" r="11" fill="none"
        stroke="${ACCENT}" stroke-width="4" />`;
  } else if (preset === 'bag-lock') {
    external = `
      <g class="mal-deployment">
        <g transform="translate(0 -415) scale(1.12)">${pilotChute('')}</g>
        <path d="M0-386V-221" stroke="${LINE}" stroke-width="2" />
        <rect class="mal-bag" x="-25" y="-221" width="50" height="38" rx="9"
          fill="${DARK_FABRIC}" stroke="rgba(253,241,224,.5)" stroke-width="2" />
        <path d="M-12-183L-18 114 M0-183L-10 114 M12-183L-2 114"
          fill="none" stroke="${LINE}" stroke-width="2" />
      </g>`;
  } else if (preset === 'streamer') {
    external = `
      <g class="mal-deployment">
        <g transform="translate(0 -430)">${pilotChute('')}</g>
        <path d="M0-404V-290" stroke="${LINE}" stroke-width="2" />
        <path class="mal-streamer" d="M0-290 C24-264-22-244 5-220 S-18-174 0-150 S12-126 0-115"
          fill="none" stroke="${FABRIC}" stroke-width="13" stroke-linecap="round" />
        <path d="M-4-113L-16 114 M4-113L-4 114" fill="none" stroke="${LINE}" stroke-width="2" />
      </g>`;
  }

  /* The viewBox is the exact stage band the Motion Canvas rig occupied
     (x 80..780 of 1920, full 1080 height), with the rig root at its
     original stage position, so every original coordinate carries over. */
  return `
    <svg viewBox="80 -540 700 1080" role="img"
      aria-label="Originalets animation för ${preset}">
      <style>${styles}</style>
      <g transform="translate(430 -40)">
        <g>${streaks()}</g>
        ${jumper(bodyClass, overlay)}
        ${external}
      </g>
    </svg>`;
};

const stationPoints = (sags, squeeze) => {
  const top = [];
  const bottom = [];
  for (let index = 0; index < 9; index++) {
    const baseX = (index - 4) * 62;
    const t = (index - 4) / 4;
    const arc = t * t * 52;
    const tip = index === 0 || index === 8 ? 9 : 0;
    top.push([baseX * squeeze, arc - 180 + tip + sags[index]]);
    bottom.push([baseX * squeeze, arc - 120 - tip * .7 + sags[index]]);
  }
  return {top, bottom};
};

/* The original wing is a closed Motion Canvas spline (smoothness 0.45);
   a cardinal-spline bezier through the same stations reproduces it. */
const smoothClosedPath = (points, smoothness = 0.45) => {
  const count = points.length;
  const at = index => points[((index % count) + count) % count];
  let path = `M${at(0)[0].toFixed(1)} ${at(0)[1].toFixed(1)}`;
  for (let index = 0; index < count; index++) {
    const p0 = at(index - 1);
    const p1 = at(index);
    const p2 = at(index + 1);
    const p3 = at(index + 2);
    const c1 = [p1[0] + (p2[0] - p0[0]) * smoothness / 3, p1[1] + (p2[1] - p0[1]) * smoothness / 3];
    const c2 = [p2[0] - (p3[0] - p1[0]) * smoothness / 3, p2[1] - (p3[1] - p1[1]) * smoothness / 3];
    path += ` C${c1[0].toFixed(1)} ${c1[1].toFixed(1)} ${c2[0].toFixed(1)} ${c2[1].toFixed(1)} ${p2[0].toFixed(1)} ${p2[1].toFixed(1)}`;
  }
  return `${path} Z`;
};

/* Motion Canvas polylines round their middle vertex with a corner radius;
   the draped line-over uses that shape, not a single quadratic arc. */
const roundedPolyline = (start, corner, end, radius) => {
  const arm = (from, to) => {
    const dx = to[0] - from[0];
    const dy = to[1] - from[1];
    const length = Math.hypot(dx, dy);
    return [dx / length, dy / length, length];
  };
  const [ux1, uy1, length1] = arm(corner, start);
  const [ux2, uy2, length2] = arm(corner, end);
  const cut = Math.min(radius, length1 / 2, length2 / 2);
  const p1 = [corner[0] + ux1 * cut, corner[1] + uy1 * cut];
  const p2 = [corner[0] + ux2 * cut, corner[1] + uy2 * cut];
  return `M${start.join(' ')} L${p1[0].toFixed(1)} ${p1[1].toFixed(1)}` +
    ` Q${corner.join(' ')} ${p2[0].toFixed(1)} ${p2[1].toFixed(1)} L${end.join(' ')}`;
};

const canopyVisual = preset => {
  const config = {
    'line-over': {sags: [0, 0, 9, 34, 78, 34, 9, 0, 0], squeeze: 1},
    tangled: {sags: [0, 0, 0, 0, 0, 0, 14, 24, 34], squeeze: 1},
    'broken-lines': {sags: [0, 0, 0, 0, 26, 22, 0, 0, 0], squeeze: 1},
    'slider-hang': {sags: [0, 0, 0, 0, 0, 0, 0, 0, 0], squeeze: .55},
    'line-twist': {sags: [0, 0, 0, 0, 0, 0, 0, 0, 0], squeeze: .6},
  }[preset];
  const {top, bottom} = stationPoints(config.sags, config.squeeze);
  const riser = index => index <= 4 ? [-18, 240] : [18, 240];
  const knot = [46, 122];
  const twisted = preset === 'line-twist';
  // Suspension lines are slightly lighter than brake lines in the original.
  const SUSPENSION = 'rgba(120,110,130,.75)';
  const lines = bottom.map((point, index) => {
    if (preset === 'tangled' && index >= 5) {
      return `<path d="M${point.join(' ')}L${knot.join(' ')}" stroke="${SUSPENSION}" stroke-width="2" />`;
    }
    if (preset === 'broken-lines' && (index === 4 || index === 5)) {
      const end = [point[0] + (index === 4 ? -5 : 5), point[1] + (index === 4 ? 64 : 60)];
      return `<path class="mal-broken" d="M${point.join(' ')}L${end.join(' ')}"
        stroke="${ACCENT}" opacity=".7" stroke-width="3" />`;
    }
    const end = twisted ? [0, 28] : riser(index);
    return `<path d="M${point.join(' ')}L${end.join(' ')}" stroke="${SUSPENSION}" stroke-width="2" />`;
  }).join('');
  const seams = top.slice(1, -1).map((point, offset) => {
    const index = offset + 1;
    return `<path d="M${point[0]} ${point[1] + 3}L${bottom[index][0]} ${bottom[index][1] - 3}"
      stroke="rgba(60,50,80,.3)" stroke-width="1.5" />`;
  }).join('');
  const toggles = twisted ? '' : `
    <path d="M${bottom[0].join(' ')}L-80 244 M${bottom[8].join(' ')}L80 244"
      stroke="${LINE}" stroke-width="2" stroke-dasharray="6 6" />
    <circle cx="-80" cy="244" r="10" fill="${ACCENT}" />
    <circle cx="80" cy="244" r="10" fill="${ACCENT}" />`;
  let effect = '';
  if (preset === 'line-over') {
    effect = `<path class="mal-over-line"
      d="${roundedPolyline([-252, -58], [0, -186 + config.sags[4]], [252, -52], 90)}"
      fill="none" stroke="${ACCENT}" stroke-width="5" stroke-linecap="round" />`;
  } else if (preset === 'tangled') {
    effect = `
      <path d="M${knot.join(' ')}L18 240" stroke="${LINE}" stroke-width="4" />
      <g class="mal-knot" transform="translate(${knot.join(' ')})">
        <circle r="11" fill="none" stroke="${ACCENT}" stroke-width="4" />
        <path d="M-17-5L17 5" stroke="${ACCENT}" stroke-width="4" />
      </g>`;
  } else if (preset === 'slider-hang') {
    effect = `<rect class="mal-slider" x="-85" y="82" width="170" height="20" rx="7"
      fill="rgba(244,240,230,.92)" stroke="${ACCENT}" stroke-width="4" />`;
  } else if (preset === 'line-twist') {
    effect = `
      <rect class="mal-slider" x="-60" y="16" width="120" height="20" rx="7"
        fill="rgba(244,240,230,.92)" stroke="${ACCENT}" stroke-width="4" />
      <path class="mal-braid" d="M-14 40L14 90L-14 140L14 190L0 240
        M14 40L-14 90L14 140L-14 190L0 240" fill="none"
        stroke="${ACCENT}" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />`;
  }
  const wingClass = preset === 'slider-hang' ? 'mal-slider-wing' : '';
  /* Same stage-band viewBox as the freefall rigs; the canopy root sits at
     its original stage position and scale. */
  return `
    <svg viewBox="80 -540 700 1080" role="img" aria-label="Originalets animation för ${preset}">
      <style>${styles}</style>
      <g transform="translate(430 -100) scale(1.05)">
        <g class="mal-canopy-root">
          <g class="mal-wing-system ${wingClass}">
            ${lines}
            ${toggles}
            <path d="${smoothClosedPath([...top, ...bottom.slice().reverse()])}" fill="${FABRIC}"
              stroke="rgba(60,50,80,.35)" stroke-width="1.5" />
            ${seams}
            ${effect}
          </g>
          <g transform="translate(0 300)">
            <circle cy="-38" r="13" fill="${INK}" />
            <rect x="-21" y="-25" width="42" height="66" rx="17" fill="${INK}" />
          </g>
        </g>
      </g>
    </svg>`;
};

export default function malfunctionLayer() {
  let target;
  return {
    mount(nextTarget) {
      target = nextTarget;
      const componentId = target.dataset.component;
      const spec = SPECS[componentId];
      if (!spec) throw new Error(`Unknown malfunction component "${componentId}"`);
      const runtime = document.createElement('div');
      runtime.className = 'malfunction-runtime';
      runtime.dataset.component = componentId;
      runtime.dataset.malfunctionKind = spec.kind;
      runtime.dataset.preset = spec.preset;
      runtime.dataset.libraryCard = String(target.classList.contains('component-preview'));
      runtime.innerHTML = spec.kind === 'freefall'
        ? freefallVisual(spec.preset)
        : canopyVisual(spec.preset);
      target.replaceChildren(runtime);
    },
    unmount() {
      target?.replaceChildren();
      target = undefined;
    },
  };
}
